import React from "react";
import "./Filter_offcanvas.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import Green_round_btn from "../../../common-components/common_btn/green_round_btn/Green_round_btn";
import { Accordion, Form } from "react-bootstrap";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";

function Filter_offcanvas({ show, handleClose, ...props }) {
  const [modalShow, setModalShow] = React.useState(false);
  const handleClick = () => {
    setModalShow(true);
    setTimeout(() => {
      setModalShow(false);
    }, 3000);
  };
  return (
    <>
      <Offcanvas
        className="Filter_offcanvas"
        show={show}
        onHide={handleClose}
        placement="start"
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4 className="heading_text">Filters</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="Accordion_holder">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Price</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Brand</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="2">
                <Accordion.Header>Category</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Pack Size</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>Discounts / Offers</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}
            </Accordion>
          </div>
          <Green_round_btn btnText={"Apply"} onClick={handleClick} />
        </Offcanvas.Body>
      </Offcanvas>

      <Success_Modal
        show={modalShow}
        onHide={() => { setModalShow(false) }}
        successText="Apply Successfully!"
      />
    </>
  );
}

export default Filter_offcanvas;
